import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>

  //This is before react-snap
  // document.getElementById('root')

  //This is after react-snap
  const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(  <React.StrictMode>
    <App />
  </React.StrictMode>, rootElement);
} else {
  ReactDOM.render(  <React.StrictMode>
    <App />
  </React.StrictMode>, rootElement);
}
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
